module.exports = __webpack_public_path__ + "static/media/turkish-people2.d0ba4786.svg";